export class VatGroup {
	VentilationCode:string;
	VATPercentage:number;
	TotalExcl:number;
	TotalVAT:number;
	TotalIncl:number;
	RoundedTotal:number;
	Mtvh:number;
	FinancialReductionAmount:number;
	TaxExempt:boolean;
	TaxExemptionReasons:string[];
	// Additional field from XML parsing
	TaxCategoryID: string;

	public constructor(data:any){
		this.VentilationCode = data.VentilationCode || "";
		this.VATPercentage = data.VATPercentage || 0.0;
		this.TotalExcl = data.TotalExcl || 0.0;
		this.TotalVAT = data.TotalVAT || 0.0;
		this.TotalIncl = data.TotalIncl || 0.0;
		this.RoundedTotal = data.RoundedTotal || 0.0;
		this.Mtvh = data.Mtvh || 0.0;
		this.FinancialReductionAmount = data.FinancialReductionAmount || 0.0;
		this.TaxExempt = data.TaxExempt || false;
		this.TaxExemptionReasons = data.TaxExemptionReasons || [];
		// Additional field from XML
		this.TaxCategoryID = data.TaxCategoryID || "";
	}
}